import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';
import { postMethodWithToken } from 'services/apiServices';

// Action Types
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE';

// Action Creators
export const fetchRegisterUser = () => ({
  type: REGISTER_USER,
});

export const fetchRegisterUserSuccess = (data) => ({
  type: REGISTER_USER_SUCCESS,
  payload: data,
});

export const fetchRegisterUserFailure = (error) => ({
  type: REGISTER_USER_FAILURE,
  payload: error,
});

// Thunk Function
export const registerUserCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchRegisterUser(data, external));
    try {
      const requestBody = {
        phone: data.phone || '',
        full_name: data.full_name || '',
        gender: data.gender || '',
        country_code: data.country_code || '',
        user_role: 'walk-in-user',
        last_name: data.last_name || '',
      };

      const response = await postMethodWithToken(url.registerUser, requestBody);

      if (response.status === 200 || response.status === 201) {
        dispatch(fetchRegisterUserSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchRegisterUserFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchRegisterUserFailure(error.message));
      if (external && external.toast) {
        external.handleToastError(error.response);
      }
    }
  };
};
